// extracted by mini-css-extract-plugin
export default {"ownerGroupToggle":"ParentAndChain_ownerGroupToggle__JFC4b","container":"ParentAndChain_container__Serdc","chainLogo":"ParentAndChain_chainLogo__0j58x"};